module.exports = __webpack_public_path__ + "img/home-help1.0c3cd125.png";